import { css } from "@compiled/react";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";

import {
    ReturnToProductSubheading,
    WelcomeBackHeading
} from "../../../components";

export const CurrentProductUser = () => (
    <ConfluenceOverlayTemplate size="sm">
        <div css={containerCss}>
            <WelcomeBackHeading />
            <ReturnToProductSubheading />
            <SiteActivation
                CurrentProductUser={<ReturnToProduct />}
                useContactExpandCohortLogic={true}
            />
        </div>
    </ConfluenceOverlayTemplate>
);

const containerCss = css({
    display: "grid",
    gap: "10px"
});
